const reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
const reIsPlainProp = /^\w*$/;
const rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
const reEscapeChar = /\\(\\)?/g;
const emptyObject = Object.create(null);
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
    if (Array.isArray(value)) {
        return false;
    }
    const type = typeof value;
    if (type === 'number' ||
        type === 'symbol' ||
        type === 'boolean' ||
        value == null) {
        return true;
    }
    return (reIsPlainProp.test(value) ||
        !reIsDeepProp.test(value) ||
        (object != null && value in Object(object)));
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
function stringToPath(string) {
    const result = [];
    if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
    }
    string.replace(rePropName, (match, number, quote, subString) => {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
        return match;
    });
    return result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
    if (Array.isArray(value)) {
        return value;
    }
    const propertyName = value;
    return isKey(propertyName, object)
        ? [propertyName]
        : stringToPath(String(propertyName));
}
function getPropByPath(obj, path, defaultValue) {
    let currentValue = obj;
    for (const key of path) {
        currentValue = currentValue?.[key];
        if (currentValue === undefined)
            return defaultValue;
    }
    return currentValue;
}
export function getPropGetter(path, defaultValue) {
    const processedPath = castPath(path, emptyObject);
    if (processedPath.length === 1 && processedPath[0] === path) {
        return (obj) => {
            const value = obj[path];
            return value === undefined ? defaultValue : value;
        };
    }
    return (obj) => {
        if (path in obj) {
            const value = obj[path];
            return value === undefined ? defaultValue : value;
        }
        return getPropByPath(obj, processedPath, defaultValue);
    };
}
export function flattenReducer(acc, arr) {
    if (Array.isArray(arr)) {
        for (const item of arr)
            acc.push(item);
    }
    else {
        acc.push(arr);
    }
    return acc;
}
export function fastJoin(arr, separator) {
    let isFirst = true;
    return arr.reduce((acc, elem) => {
        if (elem === null || elem === undefined) {
            elem = '';
        }
        if (isFirst) {
            isFirst = false;
            return `${elem}`;
        }
        return `${acc}${separator}${elem}`;
    }, '');
}
//# sourceMappingURL=utils.js.map